export enum AmazonURLStatus {
  MISSING = "MISSING",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  AWAITING_COMPLETION = "AWAITING_COMPLETION",
  COMPLETED = "COMPLETED",
}